export default "__VITE_ASSET__C6oI4BzI__"